/**
 * Utility function that hashes a stringified object containing some unique value
 * and returns a hashed numeric value.
 * Performs @ ~900k ops/sec
 * @param {string} stringified numeric hash
 */
const generateHash = (str) => {
  let hash = 0;
  const len = str.length;

  if (len === 0) {
    return hash;
  }

  for (let i = 0; i < len; i += 1) {
    hash = (hash << 5) - hash + str.charCodeAt(i);
    hash |= 0; // Convert to 32bit integer
  }

  return hash;
};

const stringify = (obj) => JSON.stringify(obj);

/**
 * Utility function that stringifies an object containing some unique value
 * and returns a hashed stringified value
 * @param {object}
 */
export const createEncodedKey = (strOrObj) =>
  stringify(generateHash(stringify(strOrObj)));
